import { Button } from "@mui/material";

import { CourtResponse } from "@/api";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useCourtEdit } from "@/pages/system-settings/tabs/courts/vienna/hooks/useCourtEdit";
import { useTranslation } from "@/translations";

import { CourtFormFields } from "./court-form-fields/CourtFormFields";

interface Props {
  court: CourtResponse;
  onClose: () => void;
}

export function CourtEditDialog({ court, onClose }: Props) {
  const { t } = useTranslation();
  const { formik, handleDelete, isDeleting } = useCourtEdit(court, onClose);

  return (
    <FormDialog
      title={t("settings.courts.edit.dialogTitle", { name: court.name })}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
      submitDisabled={!formik.dirty}
      paperSx={{ width: 1200 }}
      extraAction={{
        left: (
          <Button variant="outlined" color="error" onClick={handleDelete} disabled={isDeleting || formik.isSubmitting}>
            {t("common.delete")}
          </Button>
        ),
      }}
    >
      <CourtFormFields formik={formik} courtId={court.id} />
    </FormDialog>
  );
}
